import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { cmsService } from "../../services/api";
import LoadingSpinner from "../../components/common/LoadingSpinner";
import NotFound from "../errors/NotFound";

function CMSPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    loadPage();
  }, [slug]);

  const loadPage = async () => {
    try {
      setIsLoading(true);
      const response = await cmsService.getPage(slug);

      if (response.data.success) {
        setPage(response.data.data);
        document.title = `${response.data.data.metaTitle || response.data.data.title} - KsLnk`;
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setNotFound(true);
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <LoadingSpinner size="lg" text="Sayfa yükleniyor..." />
      </div>
    );
  }

  if (notFound || !page) {
    return <NotFound />;
  }

  return (
    <div className="py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <article className="card">
          <div className="card-body prose prose-lg max-w-none">
            <h1>{page.title}</h1>
            <div dangerouslySetInnerHTML={{ __html: page.content }} />
          </div>
        </article>
      </div>
    </div>
  );
}

export default CMSPage;
